import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Card,
  CardContent,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core"
import DownloadFileButton from "./DownloadFileButton"
import QuarterlyUploadFileButton from "./QuarterlyUploadFileButton"
import { green, red } from "@material-ui/core/colors"
import { SchemaContext } from "../contexts/SchemaContext"
import { useContext } from "react"

const useStyles = makeStyles((theme) => ({
  card: {
    "& > *": {
      margin: theme.spacing(1),
    },
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  cardContent: {
    width: 300,
  },
  error: {
    color: red[500],
  },
  input: {
    display: "none",
  },
  title: {
    fontSize: 20,
    textTransform: "uppercase",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  button: {
    minWidth: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    position: "relative",
  },
  downloadBtn: {
    marginLeft: 0,
  },
}))

const QuarterlyPostPurchCard = () => {
  const [mediaType, setMediaType] = useState("")
  const classes = useStyles()
  const { schema, schemaLoading, schemaError } = useContext(SchemaContext)

  // 4 hardcoded ... tbd map to post/purch in sequelize
  const mediaTypes = schema.filter((button) => button.button_type_id === 4)

  const handleChange = (event) => {
    setMediaType(event.target.value)
  }

  const resetForm = () => {
    setMediaType("")
  }

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          QUARTERLY PURCH/POST
        </Typography>
        {schemaLoading && <p className="loading">loading ... </p>}
        {schemaError && <p className={classes.error}>Error: {schemaError}</p>}
        {mediaTypes && !schemaError && (
          <>
            <FormControl className={classes.formControl}>
              <InputLabel id="media-select-label">Media</InputLabel>
              <Select
                labelId="media-select-label"
                id="media-simple-select"
                value={mediaType}
                onChange={handleChange}
              >
                {mediaTypes.map((item) => (
                  <MenuItem key={item.id} value={item.folder_name}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <QuarterlyUploadFileButton
              saveActivity={null}
              maxQuarters={1}
              label={"UPLOAD EXCEL FILE"}
              disabled={mediaType === ""}
              context={mediaType}
              inline={false}
              callBack={resetForm}
              mediaType={mediaType}
            />
            <DownloadFileButton
              label="Download Excel Template"
              fileName={mediaType}
              callBack={resetForm}
              disabled={mediaType === ""}
              context={mediaType}
            />
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default QuarterlyPostPurchCard
